import { useMemo } from 'react'

import { Button } from '@/components/ui/button'
import { Ping } from '@/components/ui/ping'
import RenderIf from '@/components/ui/render-if'
import { PATH_NAME } from '@/config'
import { useUnreadCount } from '@/data'
import { useIsMd, useWallet } from '@/hooks'
import { useFormatListTrades } from '@/hooks/trade/use-trades'
import { CommonHistory } from '@/icons'
import { cn } from '@/lib'
import { useTradePersistStore } from '@/store'
import { canShowFastTrade } from '@/utils'

import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

export const HistoryButton = () => {
  const isMd = useIsMd()
  const { t } = useTranslation()
  const { wallets, walletAddresses } = useWallet()
  const { fromToken } = useTradePersistStore()
  const { data: unReadCountData } = useUnreadCount({ walletAddresses })
  const walletRightChain = wallets[fromToken?.networkId ?? '']
  const connectedWallet = walletRightChain || Object.values(wallets).find((wallet) => wallet?.isConnected)
  const { processedTrades } = useFormatListTrades({ refetchInterval: 30_000 })
  const hasUnreadNotifications = useMemo(() => {
    return unReadCountData?.count || processedTrades.some((tradeDetail) => canShowFastTrade({ tradeDetail }))
  }, [unReadCountData, processedTrades])
  const { pathname } = useLocation()
  const isActive = pathname === PATH_NAME.HISTORY
  return (
    <RenderIf condition={connectedWallet}>
      <Link to={PATH_NAME.HISTORY}>
        <div className='relative'>
          <Button
            variant={isMd ? 'secondary' : 'icon'}
            size={isMd ? 'default' : 'sm'}
            className={cn(
              'bg-transparent w-8 md:w-auto md:px-5 transition-all duration-300 hover:ring-main-100 hover:bg-main-8',
              {
                'ring-main-100 bg-main-8': isActive,
              }
            )}
          >
            <CommonHistory className='size-5 md:size-6' />
            <RenderIf condition={isMd}>{t('title.HISTORY')}</RenderIf>
          </Button>
          <RenderIf condition={hasUnreadNotifications}>
            <Ping />
          </RenderIf>
        </div>
      </Link>
    </RenderIf>
  )
}
